export default {
    csManagement: {
        page: {
            title: 'CS管理センター',
            description: 'テナントクォータ、ドキュメント総量、Token消費の管理',
        },
        quota: {
            searchPlaceholder: 'テナントIDで検索',
            typePlaceholder: 'クォータタイプ',
            search: '検索',
            create: 'クォータ追加',
            tenantId: 'テナントID',
            quotaType: 'クォータタイプ',
            typeDocument: 'ドキュメント総量',
            typeToken: 'Token消費総量',
            quotaLimit: '上限',
            quotaUsed: '使用済み',
            contractPeriod: '契約期間',
            contractStart: '契約開始',
            contractEnd: '契約終了',
            status: 'ステータス',
            statusActive: '有効',
            statusExpired: '期限切れ',
            remark: '備考',
            action: '操作',
            edit: '編集',
            delete: '削除',
            createTitle: 'クォータ追加',
            editTitle: 'クォータ編集',
            cancel: 'キャンセル',
            confirm: '確認',
            saving: '保存中...',
            featureConfig: '機能設定',
            featureConfigTitle: '機能権限設定',
            featureDisclosure: '発明開示書',
            featureDisclosureDesc: '発明開示書作成機能',
            featurePatentDraft: '特許出願',
            featurePatentDraftDesc: '特許出願書類作成機能',
            featureProsecution: 'OAR応答',
            featureProsecutionDesc: '審査意見応答作成機能',
            userQuotaTitle: 'ユーザークォータ詳細',
            userQuotaHint: '会社クォータ上限：{limit} 回',
            userEmail: 'ユーザーメール',
            unlimited: '無制限',
            addUser: 'ユーザー追加',
            addUserPlaceholder: 'メールアドレスを入力',
            reset: 'クリア',
            tenantName: '会社名',
            configuredMembers: '設定済みメンバー',
            noConfiguredMembers: 'この会社には設定済みメンバーがいません',
            tenantInfoNotFound: '会社が見つかりません',
            tenantInfoFailed: '取得に失敗しました。後でもう一度お試しください',
            featureList: '機能一覧',
            featureAll: 'すべて',
        },
    },
}
